module.exports = __webpack_public_path__ + "static/mom_n_me-dc4bd23577348dd81c9d6b489abebe5a.jpg";